import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import uuid from 'uuid';

import { ButtonGroup } from '../../../../../../../components';
import { selectMediaExport } from '../../../../../../../store/modules/articles/selectors';
import { getUrlWithoutQuery } from '../../../../../../../utility/helpers';
import useStyles from '../styles';
import { getLargeVideoThumbnailUrl } from '../../../utils';
import { addDownloadMedia } from '../../../../../../../store/modules/articles/actions';

const DownloadVideoThumbnailAction = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { media } = useSelector(selectMediaExport);

  const downloadThumbnail = useCallback((isCurrentFrame: boolean = false) => {
    return () => {
      if (media && media.ref.video) {
        const { video } = media.ref;
        let url = getLargeVideoThumbnailUrl(video.ref.thumbnails || []);
        if (url) {
          if (isCurrentFrame && window.mediaPlayerRef) {
            const currentVideoTime = window.mediaPlayerRef.currentTime;
            if (currentVideoTime) {
              url = getUrlWithoutQuery(url);
              url += `?height=1080&width=1920&time=${currentVideoTime}&fit_mode=preserve`;
            }
          }
          const ext = getUrlWithoutQuery(url).split('.').pop();
          const fileName = `${video.ref.filename_base}.${ext}`;
          dispatch(
            addDownloadMedia({
              url,
              name: fileName,
              downloadId: uuid(),
              urlRequested: false,
            }),
          );
        }
      }
    }
  }, [dispatch, media]);

  if (media && media.ref.video) {
    const { video } = media.ref;
    if (video.ref.thumbnails && video.ref.thumbnails.length > 0) {
      const buttons = [
        {
          title: 'Download',
          titleList: 'Download video thumbnail',
          onClick: downloadThumbnail(),
          disabled: false,
        },
        {
          title: 'Download',
          titleList: 'Download current frame thumbnail',
          onClick: downloadThumbnail(true),
          disabled: false,
        },
      ];

      return (
        <ButtonGroup
          buttons={buttons}
          color="default"
          variant="text"
          className={classes.groupAction}
        />
      );
    }
  }

  return null;
};

export default DownloadVideoThumbnailAction;
